<script lang="ts">
    export let src: string, alt: string

    let shouldZoom = false,
        imagePosition: HTMLButtonElement,
        zoomFactor = 3, // Example zoom factor, adjust for stronger or weaker zoom
        initialClickPosition = { x: 0, y: 0 },
        currentPosition = { x: 0, y: 0 },
        coordX = 0,
        coordY = 0,
        lastTouchMoveEvent: number = 0

    function handleMousemove(event: MouseEvent) {
        if (!shouldZoom) return
        updatePosition(event.clientX, event.clientY)
    }

    function handleTouchMove(event: TouchEvent) {
        if (!shouldZoom) return
        event.preventDefault()
        const now = Date.now()
        if (now - lastTouchMoveEvent < 10) return
        lastTouchMoveEvent = now
        updatePosition(event.touches[0].clientX, event.touches[0].clientY)
    }

    function handleClick(event: MouseEvent | TouchEvent) {
        shouldZoom = !shouldZoom
        if (shouldZoom) {
            if (event instanceof MouseEvent) {
                handleMousemove(event)
            } else if (event instanceof TouchEvent) {
                handleTouchMove(event)
            }
        } else {
            resetPosition()
        }
    }

    function updatePosition(clientX: number, clientY: number) {
        var rect = imagePosition.getBoundingClientRect()
        currentPosition.x = clientX - rect.left
        currentPosition.y = clientY - rect.top
        coordX = currentPosition.x * -1 * zoomFactor
        coordY = currentPosition.y * -1 * zoomFactor
    }

    function resetPosition() {
        initialClickPosition.x = 0
        initialClickPosition.y = 0
        coordX = 0
        coordY = 0
    }
</script>

<div class="imageholder">
    <button
        class="image"
        class:allowZoom="{shouldZoom}"
        on:click="{handleClick}"
        on:mousemove="{handleMousemove}"
        on:touchmove="{handleTouchMove}"
        bind:this="{imagePosition}"
    >
        <img
            src="{src}"
            alt="{alt}"
        />
        <div class="zoomimg">
            <img
                src="{src}"
                alt="{alt}"
                style="left: {coordX}px; top: {coordY}px;"
            />
        </div>
    </button>
</div>

<style lang="less">
    .imageholder {
        width: fit-content;
        max-width: 100%;
        height: 95%;
        display: flex;
        justify-content: center;
        .image {
            background: var(--white-100);
            height: 100%;
            width: 100%;
            position: relative;
            overflow: hidden;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
            }
            .zoomimg {
                opacity: 0;
                visibility: hidden;
                background: var(--white-100);
                position: absolute;
                top: 0;
                left: 0px;
                bottom: 0;
                right: 0px;
                img {
                    position: absolute;
                    width: 400%;
                    height: auto;
                    top: 0;
                    left: 0;
                    transition: top 0s ease, left 0s ease;
                }
            }
            &:hover {
                cursor: cell;
            }
            &.allowZoom:hover {
                cursor: crosshair;
                > .zoomimg {
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
</style>
